// extracted by css-extract-rspack-plugin
export default {"cls1":"CoauthorConfirmationCard-cls1_1jr","cls2":"CoauthorConfirmationCard-cls2_NfF CoauthorConfirmationCard-cls1_1jr"};